import _get from 'lodash/get'

/** True when a login/session response means the half-session needs a 2FA code. */
export const isTwoFactorRequiredError = error => {
  const status = _get(error, 'response.status')
  if (status !== 422) return false

  const code = _get(error, 'response.data.code')
  if (code === 'two_factor_auth') return true

  const message = String(_get(error, 'response.data.message') || '')
  return /two factor authentication is required/i.test(message)
}
